import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-avisos-modales',
  templateUrl: './avisos-modales.component.html',
  styleUrls: ['./avisos-modales.component.css']
})
export class AvisosModalesComponent implements OnChanges {

  @Input() tituloModal?: string;
  @Input() mensajeModal?: string;
  @Input() modalUtilizado?: string;
  @Input() mantenerModal?: boolean;
  @Input() actualizarModal?: number;
  @Input() contenido?:any;

  ngOnChanges(changes: SimpleChanges) {

    
  }

}
